"use client";
import { useScroll, useTransform, motion } from "framer-motion";
import React, { useCallback, useRef } from "react";

export const ContainerScroll = ({
  children,
  start = 0.05,
}: {
  children: React.ReactNode;
  start?: number;
}) => {
  const containerRef = useRef<any>(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
  });
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);
  const scaleDimensions = useCallback(() => {
    return isMobile ? [0.7, 0.9] : [0.8, 1];
  }, [isMobile]);

  const rotate = useTransform(scrollYProgress, [0, start], [20, 0]);
  const scale = useTransform(scrollYProgress, [0, start], scaleDimensions());
  const translate = useTransform(scrollYProgress, [0, start], [0, 20]);
  const marginBottom = useTransform(scrollYProgress, [0, start], [-150, 0]);
  return (
    <div
      className="animate-fade-up"
      style={{
        animationDelay: "1.25s",
        animationFillMode: "forwards",
        perspective: "1000px",
        opacity: 0,
      }}
      key="header"
    >
      <motion.div
        style={{
          rotateX: rotate,
          scale,
          translateY: translate,
          marginBottom,
          // marginTop,
        }}
        className="z-0 relative overflow-hidden max-w-5xl mx-auto  w-full  p-2  bg-[#222222] rounded-3xl shadow-2xl "
      >
        {children}
      </motion.div>
    </div>
  );
};
